// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1ep6M","fileBtn":"File_fileBtn__1F0iQ","closeBtn":"File_closeBtn__2wpZM","fileSelected":"File_fileSelected__2QGdj","disabled":"File_disabled__1uaRj"};